class Frame {
	constructor () {
		this.plugins = {}
	}

	get end () {
		return this.start + this.length
	}

	setScene (scene) {
		this.scene = scene
		return this
	}

	setLength (length) {
		this.length = length
		return this
	}

	setParams (params) {
		Object.keys(params).map(key => this.setPlugins(params, key))
		this.params = params
		return this
	}
	setName (name) {
		this.name = name
		return this
	}

	setPlugins (params, key) {
		const plugins = this.scene.plugins
		Object.keys(params[key]).map(name => {
			if (!plugins[name]) return false

			if (!this.plugins[key]) this.plugins[key] = {}
			this.plugins[key][name] = params[key][name]

			delete params[key][name]
		})
	}

	setStart (start) {
		this.start = start
		return this
	}

	setPrevFrame (frame) {
		this.prevFrame = frame
		return this
	}

	checkDistance (distance) {
		return this.start <= distance && distance < this.end
	}

	getPrevEndStylesFor (alias) {
		if (!this.prevFrame) return {}
		else return this.prevFrame.getEndStylesFor(alias)
	}

	getEndStylesFor (alias) {
		const param = this.params[alias]
		if (!param) return {}

		const styles = this.getPrevEndStylesFor(alias)

		Object.keys(param).map(style => {
			const data = param[style]
			if (Array.isArray(data)) styles[style] = data[1] + (data[2] || '')
			else styles[style] = data
		})

		return styles
	}

	getStyleValueFor (data, startValue, progress) {
		let [start, end, unit = ''] = data
		if (start === 'last_value') start = parseFloat(startValue)
		return `${(end - start) * progress + start}${unit}`
	}

	getStylesFor (alias, progress) {
		const param = this.params[alias]
		if (!param) return 'NO_PARAMS_FOR_ALIAS'

		const styles = this.getPrevEndStylesFor(alias)

		Object.keys(param).map(style => {
			const data = param[style]
			if (Array.isArray(data)) styles[style] = this.getStyleValueFor(data, styles[style], progress)
			else styles[style] = data
		})
		return styles
	}

	resolvePluginsFor (alias, element, progress) {
		const plugins = this.plugins[alias]
		if (!plugins) return false
		Object.keys(plugins).map(key => this.scene.plugins[key](element, progress, plugins[key]))
	}
}

export { Frame }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/scrollAnimation/Frame.js